@if (pageType()) {
  <h2 class="text-2xl font-bold mb-2">Hitta vårdgivare</h2>

  <div class="mb-4">
    @if (pageType() === DLPageTypeEnum.CARE_SERVICE_TYPE_PAGE) {
      <p>
        Sök efter vårdgivare som erbjuder {{ searchForLabel() }} på några av våra populära platser.
      </p>
    }

    @if (pageType() === DLPageTypeEnum.SYMPTOM_PAGE) {
      <p>
        Sök efter vårdgivare som kan hjälpa dig med {{ searchForLabel() }} på några av våra populära platser.
      </p>
    }
  </div>

  <div class="flex flex-wrap content-start justify-start gap-2">
    <app-ui-button
      (onClick)="searchByLocationClick()"
      [color]="'tertiary'"
      [expanded]="'pill'"
      [id]="'place-popular-nara'"
      [ngClass]="'test-popular-place-option-nara-0'"
      [size]="'sm'"
      tabindex="null"
    >
      @if (isLocationLoading() === true) {
        <app-spinner-circle
          [position]="cssPositionEnum.RELATIVE"
          [size]="'1rem'"
          class="mr-2"
        ></app-spinner-circle>
      }
      {{ SearchWidgetLabelsEnum.NARA_MIG }}
    </app-ui-button>
    @for (popularItem of popularPlaces(); let i = $index; track popularItem.id) {
      <app-ui-button
        [color]="'tertiary'"
        [expanded]="'pill'"
        [id]="'place-popular-' + (i + 1)"
        [ngClass]="'test-place-popular-option-' + (i + 1)"
        [queryParams]="popularItem.queryParams"
        [routerLink]="popularItem.routerLink"
        [size]="'sm'"
        tabindex="null"
      >
        {{ popularItem.name }}
      </app-ui-button>
    }
  </div>
}

